import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import InfoIcon from '@mui/icons-material/Info';

export function AuditPage() {
  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 2 }}>Audit-logg</Typography>
      <Paper variant="outlined" sx={{ p: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <InfoIcon color="action" />
        <Typography variant="body2" color="text.secondary">
          Endringslogg med filter og diff-visning. Implementeres i neste sprint.
        </Typography>
      </Paper>
    </Box>
  );
}
